import { render, staticRenderFns } from "./AuthTokenSection.vue?vue&type=template&id=796a3b8b&scoped=true&"
import script from "./AuthTokenSection.vue?vue&type=script&lang=js&"
export * from "./AuthTokenSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a3b8b",
  null
  
)

export default component.exports